export default "__VITE_ASSET__ClGa1C68__"